import { render, staticRenderFns } from "./goodsEdit.vue?vue&type=template&id=c18bc5ca&scoped=true"
import script from "./goodsEdit.vue?vue&type=script&lang=js"
export * from "./goodsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c18bc5ca",
  null
  
)

export default component.exports